export const SellingTerms = {
  1: "CONSIGNMENT",
  2: "FIXED",
  3: "MGP",
};

export const getSellingTermsReadyForCombo = () => {
  return Object.keys(SellingTerms).map((st) => ({ value: st, display: SellingTerms[st] }));
};
